// extracted by mini-css-extract-plugin
export var displayNone = "_s3-6";
export var imgContainer = "_s3-2";
export var overflowHidden = "_s3-3";
export var productInfoCardButtonContainer = "_s3-5";
export var productTitleText = "_s3-4";
export var rightArrow = "_s3-1";
export var rightArrowContainer = "_s3-0";